import { render, staticRenderFns } from "./SendMailModal.vue?vue&type=template&id=7c1fddb4&scoped=true"
import script from "./SendMailModal.vue?vue&type=script&lang=js"
export * from "./SendMailModal.vue?vue&type=script&lang=js"
import style0 from "./SendMailModal.vue?vue&type=style&index=0&id=7c1fddb4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1fddb4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c1fddb4')) {
      api.createRecord('7c1fddb4', component.options)
    } else {
      api.reload('7c1fddb4', component.options)
    }
    module.hot.accept("./SendMailModal.vue?vue&type=template&id=7c1fddb4&scoped=true", function () {
      api.rerender('7c1fddb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/mail/SendMailModal.vue"
export default component.exports